module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAhCAYAAABX5MJvAAABAklEQVRYhe2Wvw5EQBCHZ/FKGjqJQkJFJZ5TpfOnQkGh8xgKCXNcMskVcpbj9i7ZL5lud+fL7PoFAwAEwSiiBVakBCElCClBSAmCW2IcR+j7HqIoAk3TLhdBnnqlbVsMw5BrH2cdlyC6rsMgCFBVVXESRNM06Ps+MsbESazM84x1XaPneeIkXqmqCl3XPTKZ6yVoMkVRoG3bu2czMtljOZdn2eY+RXmfBLeF1TIJiOMYdF3nWn/5dSRJgqZpfv9hTtP0bG4YhpivI01TtCzrbEacl1hff57nnzY/L5FlGTqOc0XzYxLDMGBZls/mH8TzZnHnxJ3810/NnUgJQkoQPyHxALCMwYtqJEmeAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/1.png
// module id = A1tS
// module chunks = 1